export default __webpack_public_path__ + "static/media/Premium.fd99e1a0.png";